import assignSetting, {
  QueryParameters,
} from "@faire/web-api--source/endpoints/www/api/v2/setting/assign/post";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import { logError } from "@faire/web/common/logging";

export const handleAssignSettingAction = async (
  sduiActions: IAction[]
): Promise<unknown> => {
  const assignSettingActions = sduiActions.filter(
    (action) => action.assign_setting
  );

  if (assignSettingActions.length === 0) {
    return Promise.resolve();
  }

  try {
    const promises = assignSettingActions.map((action) => {
      const setting = action.assign_setting?.setting_name;
      if (!setting) {
        return Promise.resolve();
      }

      return assignSetting(
        QueryParameters.build({ setting, client_created_at: Date.now() })
      );
    });

    return Promise.all(promises);
  } catch (error) {
    logError(error);
    return Promise.reject(error);
  }
};
